import { Component } from "react";
import toast from "react-hot-toast";
import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faClose, faTrash } from "@fortawesome/free-solid-svg-icons";
import InputField from "../../components/inputField/inputField";
import ToggleSwitch from "../../components/toggleSwitch";
import { addUpdateApi, getAllApi, uploadImageApi } from "../../api";
import withRouter from "../../components/withRouter/withRouter";

class AddUpdateHeroCareer extends Component {
  state = {
    imageUrl: "",
    imageObject: "",
    imageCaption: "",
    imageAlt: "",
    content: "",
    loading: true,
    numbers: [],
    _id: "",
    heroData: [],
  };

  componentDidMount = () => {
    this.getData();
  };

  getData = () => {
    getAllApi("career")
      .then((res) => {
        const d = res.data[0]?.hero;

        if (this.props.router.params?.id) {
        }
        this.setState({
          _id: res.data[0]._id,
          heroData: res.data[0]?.hero || [],
          loading: false,
        });
      })
      .catch((err) => {
        toast.error("Something went wrong while fetching data.");
      });
  };

  handleImage = (event) => {
    this.setState({
      imageUrl: URL.createObjectURL(event.target.files[0]),
      imageObject: event.target.files[0],
    });
  };

  uploadImage = async () => {
    if (this.state.imageObject) {
      try {
        const response = await uploadImageApi(
          this.state.imageObject,
          "solution"
        );
        return response.data.imageUrl;
      } catch (error) {
        throw error;
      }
    }
    return this.state.imageUrl;
  };

  validate = () => {
    if (!this.state.imageUrl) {
      toast.error("Image is required.");
      return false;
    }
    if (!this.state.imageCaption) {
      toast.error("Image Caption is required.");
      return false;
    }
    if (!this.state.imageAlt) {
      toast.error("Image Alt is required.");
      return false;
    }
    if (!this.state.content) {
      toast.error("Content is required.");
      return false;
    }

    return true;
  };

  handleSubmit = () => {
    if (this.validate()) {
      this.setState({ loading: true });
      this.uploadImage()
        .then((r) => {
          const data = {
            image: r,
            imageCaption: this.state.imageCaption,
            imageAlt: this.state.imageAlt,
            content: this.state.content,
            numbers: this.state.numbers,
          };

          console.log("Value of r is ::: ", data);

          console.log(this.props);

          if (this.props.router.params?.id) {
          } else {
            const hero = [...this.state.heroData, { ...data }];

            console.log("Data to Upload :::: ", hero);

            addUpdateApi({
              data: { heroCarousel: hero },
              type: "career",
              method: "patch",
              id: this.state._id,
            })
              .then((res) => {
                toast.success("Updated successfully.");
                this.setState({ loading: false });
                this.props.router.navigate("/career");
              })
              .catch((err) => {
                console.log("Error: ", err);
                toast.error("Something went wrong");
                this.setState({ loading: false });
              });
          }
        })
        .catch(() => {
          toast.error("Error While uploading image.");
          this.setState({ loading: false });
        });
      //   console.log("inside handle submit");
      //   this.setState({ loading: true });
      //   this.uploadImage()
      //     .then((r) => {
      //       console.log("uploaded image", r);
      //       const data = {
      //         image: r,
      //         imageCaption: this.state.imageCaption,
      //         imageAlt: this.state.imageAlt,
      //         title: this.state.title,
      //         subHeading: this.state.subHeading,
      //         buttonText: this.state.btnText,
      //         buttonUrl: this.state.btnUrl,
      //         buttonShow: this.state.buttonShow,
      //       };
      //       console.log(data);
      //       if (this.props.router.params?.id) {
      //         const hero = this.state.heroData.map((val) => {
      //           if (val._id === this.props.router.params?.id) {
      //             return {
      //               ...data,
      //               _id: this.props.router.params?.id,
      //             };
      //           } else return val;
      //         });
      //         updateStaffAugmentation({ hero }, this.state._id)
      //           .then((res) => {
      //             toast.success("Updated successfully.");
      //             this.setState({ loading: false });
      //             this.props.router.navigate("/staff-augmentation");
      //           })
      //           .catch((err) => {
      //             console.log("Error: ", err);
      //             toast.error("Something went wrong");
      //             this.setState({ loading: false });
      //           });
      //       } else {
      //         const hero = [
      //           ...this.state.heroData,
      //           {
      //             ...data,
      //           },
      //         ];
      //         updateStaffAugmentation({ hero }, this.state._id)
      //           .then((res) => {
      //             toast.success("Updated successfully.");
      //             this.setState({ loading: false });
      //             this.props.router.navigate("/staff-augmentation");
      //           })
      //           .catch((err) => {
      //             console.log("Error: ", err);
      //             toast.error("Something went wrong");
      //             this.setState({ loading: false });
      //           });
      //       }
      //     })
      //     .catch((er) => {
      //       toast.error("Error While uploading image.");
      //       this.setState({ loading: false });
      //     });
    }
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title="Add Hero Carousel For Career"
            showBtn1={true}
            btn1Text="Save"
            btn1Name="btn1"
            btn1type="filled"
            showBtn2={true}
            btn2Text="Cancel"
            btn2Name="btn2"
            btn2type="outlined_del"
            onClickHandler={(e) => {
              console.log(e);
              if (e.target.name === "btn1") {
                this.handleSubmit();
              } else this.props.router.navigate("/career");
            }}
          />
          <ContentBody>
            <div className="grid">
              <div className="card grid">
                <div>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      transform: "translateX(5px)",
                      marginBottom: "10px",
                    }}
                  >
                    Image
                    {this.state.imageUrl && (
                      <span
                        style={{
                          display: "inline-flex",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          color: "#CB1829",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          this.setState({ imageUrl: "", imageObject: "" });
                        }}
                        title="Delete image"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    )}
                  </p>

                  {!this.state.imageUrl ? (
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        background: "transparent",
                        border: "1px dashed grey",
                        borderRadius: "10px",
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="file"
                        style={{
                          opacity: 0,
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0,
                          cursor: "pointer",
                        }}
                        accept="image/*"
                        onChange={this.handleImage}
                      ></input>
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "45%",
                        aspectRatio: "16/9",
                        backgroundImage: `url('${
                          this.props.router.params.id
                            ? this.state.isImageChanged
                              ? this.state.imageUrl
                              : this.state.imageUrl
                            : this.state.imageUrl
                        }')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        marginBottom: "40px",
                        marginTop: "10px",
                        borderRadius: "15px",
                        position: "relative",
                      }}
                    ></div>
                  )}
                </div>
                {this.state.imageUrl && (
                  <div className="grid_2">
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Caption"}
                      value={this.state.imageCaption}
                      onChange={(e) => {
                        this.setState({ imageCaption: e.target.value });
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Alt"}
                      value={this.state.imageAlt}
                      onChange={(e) =>
                        this.setState({ imageAlt: e.target.value })
                      }
                    />
                  </div>
                )}
                <div className="grid">
                  <InputField
                    type="textarea"
                    isLabel={true}
                    lable={"Content"}
                    value={this.state.content}
                    onChange={(e) => this.setState({ content: e.target.value })}
                  />
                </div>
              </div>
              <div className="card grid">
                <h3>
                  Numbers
                  <button
                    onClick={() => {
                      this.setState({
                        numbers: [
                          ...this.state.numbers,
                          {
                            title: "",
                            number: "",
                          },
                        ],
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faAdd} /> Add
                  </button>
                </h3>
                {this.state.numbers.map((value, index) => (
                  <div key={index} className="sub_card grid_2">
                    <FontAwesomeIcon
                      icon={faClose}
                      className="sub_card_close"
                      onClick={() => {
                        let temp = this.state.numbers;
                        temp.splice(index, 1);
                        this.setState({ numbers: [...temp] });
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Title"}
                      value={value.title}
                      onChange={(e) => {
                        let temp = this.state.numbers;
                        temp[index].title = e.target.value;
                        this.setState({
                          numbers: [...temp],
                        });
                      }}
                    />
                    <InputField
                      type="number"
                      isLabel={true}
                      lable={"Number"}
                      value={value.number}
                      onChange={(e) => {
                        let temp = this.state.numbers;
                        temp[index].number = e.target.value;
                        this.setState({
                          numbers: [...temp],
                        });
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(AddUpdateHeroCareer);
